import _ from "lodash";
import axios from "axios";
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  makeStyles,
  Box,
  Button,
  Card,
  IconButton,
  CardContent,
  CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import BackupIcon from "@material-ui/icons/Backup";
import { baseUrl } from "../../config/api";
import { useSelector } from "react-redux";
import Pagination from "@mui/material/Pagination";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  input: {
    display: "none",
  },
  deleteIcon: {},
});

export const FilePicker = (props) => {
  const authToken = useSelector((state) => state.userReducer.authToken);
  const { buttonLabel, maxFiles, setNewFiles, id, filetype } = props;
  const classes = useStyles();
  const [files, setFiles] = useState(props.files);
  const inputFile = useRef(null);
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const objectUrlsRef = useRef(new Set());

  useEffect(() => {
    setFiles(props.files);
  }, [props.files]);

  // Cleanup Object URLs on unmount or when files change
  useEffect(() => {
    return () => {
      // Revoke all Object URLs to prevent memory leaks
      objectUrlsRef.current.forEach((url) => {
        URL.revokeObjectURL(url);
      });
      objectUrlsRef.current.clear();
    };
  }, []);

  const handleChangeFile = useCallback((event) => {
    const file = event.target.files;
    if (!file || file.length === 0) {
      return;
    }
    const arr = Array.from(file);

    let copy = _.isEmpty(files) ? [] : _.clone(files);
    arr.forEach((fl) => {
      let f = {
        name: fl.name,
        size: fl.size,
        type: fl.type,
        path: fl,
      };

      copy.push(f);
    });
    setNewFiles(copy);
  }, [files, setNewFiles]);

  const handleChange = useCallback((event, value) => {
    setPage(value);
  }, []);

  const _deleteFile = useCallback(async (id, index) => {
    try {
      // Revoke Object URL if it exists
      if (files[index] && files[index].path && typeof files[index].path === 'object') {
        // Find and revoke the Object URL if it was created
        const fileToDelete = files[index];
        // Note: We can't directly track which URL was created for which file
        // but we'll clean up on unmount
      }
      
      let copy = _.clone(files);
      copy.splice(index, 1);
      setFiles(copy);
      setNewFiles(copy);
    } catch (e) {
      // Silently handle errors
    }
  }, [files, setNewFiles]);

  const onDocumentLoadSuccess = useCallback(({ numPages: nextNumPages }) => {
    setNumPages(nextNumPages);
  }, []);

  const _renderImage = useCallback((file, index) => {
    let src = "";
    let children = null;

    // Normalize file
    const fileObj =
      typeof file === "string" ? { path: file } : file;

    // Case 1: No file path
    if (!fileObj || !fileObj.path) {
      children = <BackupIcon />;
    }
    // Case 2: PDF rendering
    else if (
      typeof fileObj.name === "string" &&
      fileObj.name.toLowerCase().endsWith(".pdf")
    ) {
      children = (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Document
            file={fileObj.path}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={
              <div style={{ display: "block", margin: "auto" }}>
                <CircularProgress />
              </div>
            }
          >
            {Array.from(new Array(numPages), (_, i) =>
              i === page - 1 ? (
                <Page key={`page_${i + 1}`} pageNumber={i + 1} />
              ) : null
            )}
          </Document>
          <Pagination
            count={numPages}
            page={page}
            onChange={handleChange}
            color="primary"
            className={classes.pagination}
          />
        </Box>
      );
    }
    // Case 3: Local file object (Blob/File)
    else if (typeof fileObj.path === "object") {
      src = URL.createObjectURL(fileObj.path);
      // Track Object URL for cleanup
      objectUrlsRef.current.add(src);
      
      // Cleanup this specific URL when component unmounts or file changes
      children = (
        <img
          alt="uploaded"
          src={src}
          style={{ aspectRatio: 1, width: 350, height: 200 }}
          onLoad={() => {
            // Image loaded successfully
          }}
          onError={() => {
            // Clean up on error
            if (objectUrlsRef.current.has(src)) {
              URL.revokeObjectURL(src);
              objectUrlsRef.current.delete(src);
            }
          }}
        />
      );
    }
    // Case 4: string image path
    else {
      src = fileObj.path;
      children = (
        <img
          alt="image"
          src={src}
          style={{ aspectRatio: 1, width: 350, height: 200 }}
        />
      );
    }

    return children;
  }, [numPages, page, onDocumentLoadSuccess, classes.pagination]);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      // alignItems={"center"}
      justifyContent={"center"}
      margin={"30px 0 0 0"}
    >
      <input
        ref={inputFile}
        multiple={maxFiles > 1 ? true : false}
        className={classes.input}
        // accept={".png,.jpg,.jpeg,.pdf"}
        accept={filetype}
        id={id}
        type="file"
        onChange={handleChangeFile}
      />
      <Button
        variant="contained"
        onClick={() => {
          if (files && maxFiles && maxFiles <= files.length) {
            return alert(`Only ${maxFiles} can be uploaded`);
          }
          inputFile.current.click();
        }}
        color="primary"
        className={classes.button}
        startIcon={<CloudUploadIcon />}
      >
        {buttonLabel}
      </Button>
      {files && files.length > 0 && (
        <Box
          display={"flex"}
          flexDirection={"row"}
          margin={2}
          // justifyContent={"center"}
          style={{ overflowX: "scroll" }}
        >
          {files.map((file, index) => {
            return (
              <div>
                <Card
                  style={{
                    width: "100%",
                    display: "flex",
                    marginRight: 10,
                    alignItems: "center",
                    overflow: "hidden",
                    justifyContent: "center",
                    padding: 10,
                  }}
                >
                  <Box flexDirection={"column"}>
                    <Box
                      alignItems={"center"}
                      justifyContent={"flex-end"}
                      backgroundColor={"green"}
                      flex={1}
                      display={"flex"}
                    >
                      <IconButton
                        aria-label="delete"
                        style={{ alignSelf: "flex-end" }}
                        onClick={() => {
                          if (file._id) {
                            return _deleteFile(file._id, index);
                          }
                          _deleteFile(null, index);
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    {_renderImage(file, index)}
                  </Box>
                </Card>
              </div>
            );
          })}
        </Box>
      )}
    </Box>
  );
};
